import type { QuestionFillData } from '@repo/types/questions/QuestionFill';

import { Badge } from '@/components/ui/badge';
import { processFillQuestionData, getFillContent } from '@/hooks/questions/useQuestionMarkedFill';

interface QuestionMarkedFillContentProps {
  question: QuestionFillData;
}

export function QuestionMarkedFillContent(questionMarkedFillContentProps: QuestionMarkedFillContentProps) {
  const { question } = questionMarkedFillContentProps;

  const data = processFillQuestionData(question);

  if (data.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-1">
      {data.map((content, index) => {
        const gapContent: string = getFillContent(content.content, content.gap);
        if (content.gap) {
          return (
            <Badge variant="muted" size="sm" key={index} className="h-fit text-wrap whitespace-normal">
              {gapContent}
            </Badge>
          );
        }
        return <p key={index}>{gapContent}</p>;
      })}
    </div>
  );
}
